var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 11H12.3333C11.9797 11 11.6406 11.1405 11.3905 11.3905C11.1405 11.6406 11 11.9797 11 12.3333V14.3333M23 14.3333V12.3333C23 11.9797 22.8595 11.6406 22.6095 11.3905C22.3594 11.1405 22.0203 11 21.6667 11H19.6667M19.6667 23H21.6667C22.0203 23 22.3594 22.8595 22.6095 22.6095C22.8595 22.3594 23 22.0203 23 21.6667V19.6667M11 19.6667V21.6667C11 22.0203 11.1405 22.3594 11.3905 22.6095C11.6406 22.8595 11.9797 23 12.3333 23H14.3333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPreview);
export default __webpack_public_path__ + "static/media/icn-preview.2cedcecb64bcbfaf5703d38947a84cc6.svg";
export { ForwardRef as ReactComponent };